import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import * as ActionsDialog from 'app/store/actions';
import * as Actions from './store/actions';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
	logFont: {
		fontFamily: 'Ubuntu Mono'
	}
}));

const Logs = props => {
	const { stack, type } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const logsEndRef = useRef(null);

	const [atBottom, setAtBottom] = useState(false);
	const [firstRender, setFirstRender] = useState(true);
	const logs = useSelector(({ stacks }) => stacks.stack.logs);

	const closeLogs = () => {
		dispatch(ActionsDialog.closeDialog());
		dispatch(Actions.clearLogs());
	};

	const scrollToBottom = useCallback(() => {
		setTimeout(() => logsEndRef?.current?.scrollIntoView({ behavior: 'smooth' }), 50);
	}, [logsEndRef]);

	const fetchLogs = useCallback(() => {
		dispatch(Actions.getLogsRepeat({ id: stack.id, type }))
			.then(() => atBottom && scrollToBottom())
			.catch(error => console.error("Error fetching logs:", error));
	}, [dispatch, stack.id, type, atBottom, scrollToBottom]);


	const setBottom = ({ target }) => {
		const { scrollHeight, scrollTop, clientHeight } = target;
		setAtBottom(scrollHeight - scrollTop === clientHeight);
	};

	useEffect(() => {
		if (!atBottom && firstRender) {
			setTimeout(() => logsEndRef.current.scrollIntoView(), 50);
			setFirstRender(false);
		}
	}, [firstRender, setFirstRender, atBottom]);

	useEffect(() => {
		fetchLogs();
		const intervalId = setInterval(fetchLogs, 10000);

		return () => clearInterval(intervalId);

	}, [dispatch, props, atBottom, fetchLogs]);

	return (
		<React.Fragment>
			<DialogTitle className="border-b-1">
				<div className="flex flex-row items-center justify-between">
					<span id="logs-header">{`Logs for ${props.stack.name}`}</span>
					<Button id="scroll-btn" variant="outlined" type="button" onClick={scrollToBottom}>
						Scroll To Bottom
					</Button>
				</div>
			</DialogTitle>
			<DialogContent onScroll={e => setBottom(e)}>
				<div id="logs" className={classes.logFont} dangerouslySetInnerHTML={{ __html: logs }}></div>
				<div ref={logsEndRef} />
			</DialogContent>
			<DialogActions className="border-t-1">
				<Button id="logs-close-btn" onClick={closeLogs} variant="outlined">
					Close
				</Button>
			</DialogActions>
		</React.Fragment>
	);
};

export default Logs;
